import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue";
const _hoisted_1 = {
  class: "address-map-select"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "address-map"
}, null, -1);
const _hoisted_3 = {
  class: "main-wrap address-map-select-wrap"
};
const _hoisted_4 = {
  class: "address-form"
};
const _hoisted_5 = {
  class: "address-input"
};
const _hoisted_6 = {
  class: "city"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "separator"
}, null, -1);
const _hoisted_8 = ["placeholder"];
const _hoisted_9 = {
  key: 0,
  class: "address-list"
};
const _hoisted_10 = {
  key: 0,
  class: "loading"
};
const _hoisted_11 = {
  key: 1,
  class: "address-data"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "poi"
};
const _hoisted_14 = {
  class: "name"
};
const _hoisted_15 = {
  class: "address"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
const _hoisted_17 = {
  class: "address-map-select-map-container"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  id: "address-map-select-map"
}, null, -1);
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "card",
  ref: "card"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "当前选中位置", -1);
const _hoisted_22 = {
  class: "card-main"
};
const _hoisted_23 = {
  class: "address-text"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "hint"
}, [/*#__PURE__*/_createTextVNode(" 为方便上下车，建议"), /*#__PURE__*/_createElementVNode("strong", null, "拖动位置选点至路口或者建筑物出入口"), /*#__PURE__*/_createTextVNode("。若在下方选择选点附近地址，请调至合适位置。 ")], -1);
const _hoisted_25 = {
  class: "poi-list"
};
const _hoisted_26 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_nav_bar, {
    border: false,
    title: $setup.title
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: _normalizeClass('dot ' + $setup.addressType + '-dot')
  }, null, 2), _createElementVNode("div", {
    class: "city-select",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goSelectCity && $options.goSelectCity(...args))
  }, [_createElementVNode("div", _hoisted_6, _toDisplayString($setup.cityName), 1), _createVNode(_component_van_icon, {
    name: require('@/assets/icon/arrow-down.svg'),
    color: "#333",
    size: "10px"
  }, null, 8, ["name"])]), _hoisted_7, _withDirectives(_createElementVNode("input", {
    class: "input",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.keyword = $event),
    type: "text",
    placeholder: $options.inputPlaceholder,
    onInput: _cache[2] || (_cache[2] = (...args) => $options.goPlaceSearch && $options.goPlaceSearch(...args))
  }, null, 40, _hoisted_8), [[_vModelText, $setup.keyword]])]), _createElementVNode("div", {
    class: "cancel-btn",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.goBack && $options.goBack(...args))
  }, "取消")]), $setup.keyword && $setup.keyword.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [!$setup.searchPois || $setup.searchPois.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_van_loading, {
    size: "40px",
    color: "#ff9500",
    "text-color": "#777",
    vertical: ""
  }, {
    default: _withCtx(() => [_createTextVNode(" 正在查询... ")]),
    _: 1
  })])) : _createCommentVNode("", true), $setup.searchPois && $setup.searchPois.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchPois, (poi, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "address-item",
      key: poi.id,
      onClick: $event => $options.selectSearchPoi(index)
    }, [_createVNode(_component_van_icon, {
      name: "location-o"
    }), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(poi.name), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(poi.address), 1)]), _hoisted_16], 8, _hoisted_12);
  }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [_hoisted_18, _withDirectives(_createElementVNode("img", {
    class: "pin-img",
    ref: "pin",
    src: require('@/assets/icon/map/map-pin-point.png')
  }, null, 8, _hoisted_19), [[_vShow, $setup.showPin]]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString($setup.showAddress), 1), _hoisted_24, _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pois, (poi, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass('poi-item' + (poi.id === $setup.selectPodId ? ' selected' : '')),
      onClick: $event => $options.selectPoi(index)
    }, _toDisplayString(poi.name), 11, _hoisted_26);
  }), 256))])]), _createVNode(_component_van_button, {
    color: "#ff9500",
    block: "",
    onClick: $options.enterSelect
  }, {
    default: _withCtx(() => [_createTextVNode(" 确认位置 ")]),
    _: 1
  }, 8, ["onClick"])], 512)])])]);
}